// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"707c842a","174":"fb51cbc9","189":"2fa74f7f","324":"7054f8a6","360":"95813129","470":"3b74c699","488":"d4943b07","506":"8a1b14d3","561":"930880c2","818":"c733f20a","909":"aff4d476"}[chunkId] + ".chunk.js";
};